import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../networking/client';
import { RootState } from '../store';
import { toast } from 'react-toastify';

export interface DiagnosticResult {
  service_id: number;
  sample_taken_id: number;
  work_order_id: number;
  biomarker_id: number;
  biomarker_value_result?: number;
  biomarker_text_result?: string;
  biomarker_short_abbreviation?: string;
  sample_taking_business_partner_id: number;
  sample_taking_employee_id: number;
  sample_barcode?: string;
  sample_id: number;
  sample_taking_datetime?: Date;
  biomarker_name: string;
  biomarker_uom: string;
  biomarker_external_id: number;
  diagnostic_machine_external_id: number;
  biomarker_order?: number;
  person_firstname: string;
  person_lastname: string;
}

export interface DiagnosticResultsState {
  status: string;
  diagnosticResults: DiagnosticResult[];
}

const initialState: DiagnosticResultsState = {
  status: 'idle',
  diagnosticResults: [],
};

export const fetchDiagnosticResults = createAsyncThunk(
  'diagnosticResults/fetchAll',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const diagnosticResultsResponse: any = await client.get('/healthpoint/diagnostic-results');
      return diagnosticResultsResponse;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const diagnosticResultsSlice = createSlice({
  name: 'diagnosticResults',
  initialState,
  reducers: {
    resetDiagnosticResults: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDiagnosticResults.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchDiagnosticResults.fulfilled, (state, action) => {
        state.diagnosticResults = action.payload.data.diagnosticResults;
        state.status = 'fulfilled';
      })
      .addCase(fetchDiagnosticResults.rejected, (state, action: any) => {
        toast.error(action?.payload?.error ?? 'Something went wrong.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        state.status = 'rejected';
      });
  },
});

export const { resetDiagnosticResults } = diagnosticResultsSlice.actions;

export default diagnosticResultsSlice.reducer;

export const selectDiagnosticResults = (state: RootState) =>
  state.diagnosticResults.diagnosticResults;
export const selectDiagnosticResultsStatus = (state: RootState) => state.diagnosticResults.status;
